/* react-scroll setup */
export const DURATION = 1000;
export const OFFSET = -110; //header height compensation
